import "./PlayButtonGrey.css";

const PlayButtonGrey = () => {
	return (
		<div className='play-btn-grey'>
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 40'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<circle cx='20' cy='20' r='19.5' stroke='#A1A4B2' />
				<path
					d='M17.5064 14.222C16.3918 13.5906 15 14.3813 15 15.6441V24.3528C15 25.6213 16.3918 26.4119 17.5064 25.7749L25.1641 21.4233C26.2786 20.7919 26.2786 19.2106 25.1641 18.5735M17.5064 14.222L17.2593 14.6567L17.2596 14.6569C16.4652 14.2072 15.5 14.7795 15.5 15.6441V24.3528C15.5 25.2248 16.466 25.7936 17.2582 25.3408L17.2593 25.3401L24.917 20.9886L24.9176 20.9883C25.6924 20.5494 25.6962 19.4541 24.9165 19.0079L24.917 19.0082L25.1641 18.5735M17.5064 14.222L25.1641 18.5735M17.5064 14.222L17.2599 14.6571L24.9159 19.0076L25.1641 18.5735'
					fill='#A1A4B2'
					stroke='#A1A4B2'
				/>
			</svg>
		</div>
	);
};

export default PlayButtonGrey;
